<template>
    <div>
        <slot name="activator" :open="openModal">
            <button @click="openModal" class="btn btn-transparent rounded">
                <i class="fa-solid fa-cog"></i>
            </button>
        </slot>
        <b-modal
            v-model="isModalOpen"
            :title="__('vehicle_list_settings')"
            scrollable
            hide-footer
            modal-class="table-settings-modal"
            body-class="custom-scrollbar"
        >
            <vehicle-list-settings
                v-model="vehicleListSettings"
                @saveOption="saveSettings"
            ></vehicle-list-settings>
        </b-modal>
    </div>
</template>
<script>
import VehicleListSettings from '@/components/panels/SettingsPanel/VehicleListSettings.vue'
export default {
    name: 'TableSettings',
    components: {
        VehicleListSettings
    },
    data() {
        return {
            isModalOpen: false,
            vehicleListSettings: {
                viewMode: 'list',
                // No `tableFields` here: the column list comes from the config,
                // which has its own default in the schema.
                fluidTable: false,

                vehicleIdentification: null,
                copyIdentificationToMarker: false,

                iconType: null,
                copyIconTypeToMarker: false,
                iconColor: null,
                copyIconColorToMarker: false,

                truckListItemFields: []
            }
        }
    },
    methods: {
        openModal() {
            // In case the user clicks cancel or clicks outside the container, the next time they open the modal everything will be reset
            this.setVehicleListSettingsFromConfig()
            this.isModalOpen = true
        },
        getValueFromConfig(key) {
            return this.$store.getters['config/value'](key)
        },
        setVehicleListSettingsFromConfig() {
            this.vehicleListSettings.viewMode = this.getValueFromConfig('vehicleListModeView')
            this.vehicleListSettings.fluidTable = this.getValueFromConfig('vehicleListFluidTable')
            this.vehicleListSettings.vehicleIdentification =
                this.getValueFromConfig('vehicleIdentification')
            this.vehicleListSettings.copyIdentificationToMarker = this.getValueFromConfig(
                'copyIdentificationToMarker'
            )
            this.vehicleListSettings.truckListItemFields =
                this.getValueFromConfig('truckListItemFields')
            this.vehicleListSettings.iconType = this.getValueFromConfig('iconType')
            this.vehicleListSettings.copyIconTypeToMarker =
                this.getValueFromConfig('copyIconTypeToMarker')
            this.vehicleListSettings.iconColor = this.getValueFromConfig('iconColor')
            this.vehicleListSettings.copyIconColorToMarker =
                this.getValueFromConfig('copyIconColorToMarker')
        },
        saveSettings(option, value) {
            if (typeof value === 'object' && Array.isArray(value) === false && value !== null) {
                this.$store.dispatch('config/commitChange', {
                    key: option,
                    value: { ...this.$store.state.config.user[option], ...value }
                })
                return
            }

            this.$store.dispatch('config/commitChange', { key: option, value })
        }
    },
    created() {
        this.setVehicleListSettingsFromConfig()
    }
}
</script>

<!-- Not scoped: BootstrapVue moves the modal out to <body>, so it is no longer
     a descendant of this component's root. -->
<style lang="scss">
// The settings mirror the vehicle list panel, which is itself around 380px
// wide — a wider modal would only stretch the preview out of proportion.
// Bootstrap applies this cap from 576px up; below that the modal goes
// full-screen instead (see the media query below).
.modal.table-settings-modal {
    --bs-modal-width: 600px;

    // The column list fills what the modal has left, and "what is left" only
    // exists if the modal has a height of its own: scrollable content is sized
    // by `max-height`, which leaves nothing to divide up. Full height also
    // keeps the modal still while a search filters the list.
    .modal-dialog-scrollable .modal-content {
        height: 100%;
    }

    .modal-body {
        display: flex;
        flex-direction: column;
    }
}

// On phones the modal fills the screen instead of floating in the middle:
// there is not enough room for the settings to be usable otherwise.
// Zeroing `--bs-modal-margin` lets Bootstrap's own rules (including the
// `.modal-dialog-scrollable` height calc) resolve to the full viewport.
@media (max-width: 575.98px) {
    // `.modal` is where Bootstrap declares the variable, so match its
    // specificity to make sure this wins regardless of stylesheet order.
    .modal.table-settings-modal {
        --bs-modal-margin: 0;

        .modal-dialog {
            max-width: none;
            height: 100%;
        }

        .modal-content {
            height: 100%;
            border-radius: 0;
        }
    }
}
</style>
